import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
  ModalHeader,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import { saveAs } from "file-saver"

const Banner = () => {
  const [modal_small, setmodal_small] = useState(false)
  const [modal_small2, setmodal_small2] = useState(false)
  const [banner, setbanner] = useState([])
  const [form, setform] = useState({
    name: "",
    priority: "",
    templateCategoryId: "",
  })
  const [form1, setform1] = useState([])

  const [Files, setFiles] = useState("")
  const [Files1, setFiles1] = useState("")

  const changeHandler = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }
  const changeHandler1 = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles1(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }

  function tog_small() {
    setmodal_small(!modal_small)
  }
  function tog_small2() {
    setmodal_small2(!modal_small2)
  }

  const getpopup2 = () => {
    tog_small2()
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }
  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  useEffect(() => {
    GetAllCategorys()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  console.log(datas)

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = banner.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(banner.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const AddCategory = () => {
    var token = datas
    const dataArray = new FormData()
    dataArray.append("name", form.name)
    dataArray.append("templateCategoryId", form.templateCategoryId)
    dataArray.append("priority", form.priority)
    for (let i = 0; i < Files.length; i++) {
      dataArray.append("image", Files[i])
    }
    axios
      .post(URLS.AddTemplates, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllCategorys()
            clearForm()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const EditCategory = () => {
    var token = datas
    var formid = form1._id
    const dataArray = new FormData()
    dataArray.append("name", form1.name)
    dataArray.append("templateCategoryId", form1.templateCategoryId)
    dataArray.append("priority", form1.priority)
    for (let i = 0; i < Files1.length; i++) {
      dataArray.append("image", Files1[i])
    }
    axios
      .put(URLS.EditTemplates + formid, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllCategorys()
            setmodal_small(false)
            clearForm1()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }
  // checkbox funtinality

  const [selectedIds, setSelectedIds] = useState([])
  console.log(selectedIds, "selectedIds")

  const handleSelectAll = () => {
    if (selectedIds.length === banner.length) {
      setSelectedIds([])
    } else {
      const allIds = banner.map(data => data._id)
      setSelectedIds(allIds)
    }
  }

  const handleSelectOne = _id => {
    if (selectedIds.includes(_id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== _id))
    } else {
      setSelectedIds([...selectedIds, _id])
    }
  }

  const isSelected = _id => selectedIds.includes(_id)
  const [idsToDelete, setIdsToDelete] = useState([])

  // const DeleteCategory = data => {
  //   const token = datas
  //   const remid = data._id

  //   // ID IN THE array
  //   setIdsToDelete(prevIds => [...prevIds, remid])

  //   axios
  //     .delete(URLS.DeleteTemplates + remid, {
  //       headers: { Authorization: `Bearer ${token}` },
  //       data: { id: [...idsToDelete, remid] },
  //     })
  //     .then(res => {
  //       if (res.status === 200) {
  //         toast(res.data.message)
  //         GetAllCategorys()
  //       }
  //     })
  //     .catch(error => {
  //       if (error.response && error.response.status === 400) {
  //         toast(error.response.data.message)
  //       }
  //     })
  // }

  const DeleteCategory = () => {
    if (selectedIds.length === 0) {
      toast("Select atleast one product!")
      setmodal_small2(false)
    } else {
      var token = datas
      var remid = { selectedIds }
      axios
        .delete(URLS.DeleteTemplates, {
          headers: { Authorization: `Bearer ${token}` },
          data: { id: selectedIds },
        })
        .then(
          res => {
            if (res.status === 200) {
              toast(res.data.message)
              GetAllCategorys()
              setmodal_small2(false)
            }
          },
          error => {
            if (error.response && error.response.status === 400) {
              toast(error.response.data.message)
            }
          }
        )
    }
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteCategory(data)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    AddCategory()
  }
  const handleSubmit1 = e => {
    e.preventDefault()
    EditCategory()
  }

  const GetAllCategorys = () => {
    var token = datas
    axios
      .post(
        URLS.GetTemplates,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.templates)
      })
  }
  const clearForm1 = () => {
    setFiles1({
      image: "",
    })
  }
  const clearForm = () => {
    setform({
      name: "",
      priority: "",
      templateCategoryId: "",
    })
    setFiles({
      image: "",
    })
  }

  const getpopup = data => {
    setform1(data)
    tog_small()
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        URLS.GetTemplatesSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.templates)
      })
  }
  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const [Category, setCategory] = useState([])

  useEffect(() => {
    getCategorys()
  }, [])

  const getCategorys = () => {
    var token = datas
    axios
      .post(
        URLS.GetTemplateCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCategory(res.data.templatecategory)
      })
  }

  // downliading
  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home" breadcrumbItem="Posters" />
          <Row>
            {" "}
            {Roles?.PostersAdd == true || Roles?.accessAll == true ? (
              <>
                <Col md={4}>
                  <Card>
                    <CardHeader className="bg-white">
                      <CardTitle>Add Posters</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Form
                        onSubmit={e => {
                          handleSubmit(e)
                        }}
                      >
                        <div className="mb-3">
                          <Label>Posters Category</Label>
                          <span className="text-danger">*</span>
                          <select
                            value={form.templateCategoryId}
                            name="templateCategoryId"
                            onChange={e => {
                              handleChange(e)
                            }}
                            className="form-select"
                          >
                            <option value="">Select</option>
                            {Category.map((data, key) => {
                              return (
                                <option key={key} value={data._id}>
                                  {data.name}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Posters Image <span className="text-danger">*</span>
                          </Label>
                          <span className="text-danger">390 * 159</span>
                          <Input
                            type="file"
                            className="form-control"
                            id="basicpill-firstname-input1"
                            placeholder="Enter Posters image"
                            required
                            name="image"
                            value={Files.image}
                            onChange={changeHandler}
                          />
                        </div>
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">
                            Priority
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={form.priority}
                            name="priority"
                            required
                            onChange={e => {
                              handleChange(e)
                            }}
                            className="form-select"
                          >
                            <option value="">Select</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                          </select>
                        </div>
                        <div style={{ float: "right" }}>
                          <Button color="primary" type="submit">
                            Submit <i className="fas fa-check-circle"></i>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </>
            ) : (
              ""
            )}
            <Col
              md={
                Roles?.PostersAdd == true || Roles?.accessAll == true ? 8 : 12
              }
            >
              <Card>
                <CardHeader className="bg-white">
                  <CardTitle>Posters List</CardTitle>
                </CardHeader>
                <CardBody>
                  <div>
                    <div className="table-responsive">
                      <Row className="mt-2">
                        <Col md={6}>
                          {" "}
                          <div>
                            <Button
                              onClick={() => {
                                getpopup2()
                              }}
                              className="mr-2 mt-2"
                              size="sm"
                              color="danger"
                            >
                              <i className="bx bx-trash"></i> Delete All
                            </Button>{" "}
                          </div>{" "}
                        </Col>
                        <Col md={6}>
                          <div style={{ float: "right" }}>
                            
                            <Input
                              type="search"
                              className="form-control"
                              placeholder="Search.."
                              value={search.search}
                              onChange={searchAll}
                              name="search"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Table className="table table-bordered mb-4 mt-3">
                        <thead>
                          <tr className="text-center">
                            <th>
                              <Label>Select_All</Label>
                              <Input
                                type="checkbox"
                                onClick={handleSelectAll}
                                checked={
                                  selectedIds.length === banner.length &&
                                  banner.length > 0
                                }
                                     id="deleteAll"
                                  name="selectAll"
                                readOnly
                                style={{
                                  height: "17px",
                                  width: "17px",
                                  cursor: "pointer",
                                  marginLeft: "12px",
                                }}
                              />
                            </th>
                            <th>Posters Category Name</th>
                            <th>Posters Image</th>
                            <th>Priority</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key} className="text-center">
                              <th>
                                {(pageNumber - 1) * 5 + key + 6}){" "}
                                <Input
                                  type="checkbox"
                                  id={key}
                                  name="selectAll"
                                  onClick={() => handleSelectOne(data._id)}
                                  checked={isSelected(data._id)}
                                  // readOnly
                                  style={{
                                    height: "17px",
                                    width: "17px",
                                    cursor: "pointer",
                                    marginLeft: "2px",
                                  }}
                                />
                              </th>
                              <td>{data.templateCategoryName}</td>
                              <td>
                                {/* <img
                                  style={{ width: "100px" }}
                                  src={URLS.Base + data.image}
                                /> */}
                                <div className="d-inline-block">
                                  <img
                                    style={{
                                      width: "100px",
                                      cursor: "pointer",
                                    }}
                                    src={URLS.Base + data.image}
                                    alt={`Template ${key}`}
                                    onClick={() =>
                                      downloadImage(URLS.Base + data.image)
                                    }
                                  />
                                  <i
                                    className="bx bx-download"
                                    style={{
                                      fontSize: "24px",
                                      color: "#007bff",
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      downloadImage(URLS.Base + data.image)
                                    }
                                  ></i>
                                </div>
                              </td>
                              <td>{data.priority}</td>
                              <td>
                                {" "}
                                {Roles?.PostersEdit == true ||
                                Roles?.accessAll == true ? (
                                  <>
                                    <Button
                                      onClick={() => {
                                        getpopup(data)
                                      }}
                                      className="m-1 btn-sm"
                                      color="success"
                                    >
                                      <div className="d-flex">
                                        <small>
                                          <i className="bx bx-edit m-1"></i>
                                          Edit
                                        </small>
                                      </div>
                                    </Button>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                                {Roles?.PostersDelete == true ||
                                Roles?.accessAll == true ? (
                                  <>
                                    <Button
                                      onClick={() => {
                                        manageDelete(data)
                                      }}
                                      className="m-1 btn-sm"
                                      color="danger"
                                    >
                                      <div className="d-flex">
                                        <small>
                                          <i className="bx bx-trash m-1"></i>
                                          Delete
                                        </small>
                                      </div>
                                    </Button>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Edit Posters
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <div className="mb-3">
                <Label>Posters Category Name</Label>
                <span className="text-danger">*</span>
                <select
                  value={form1.templateCategoryId}
                  name="templateCategoryId"
                  onChange={e => {
                    handleChange1(e)
                  }}
                  className="form-select"
                >
                  <option value="">Select</option>
                  {Category.map((data, key) => {
                    return (
                      <option key={key} value={data._id}>
                        {data.name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  Posters Image
                  <span className="text-danger">*</span>
                </Label>
                <span className="text-danger">390 * 159</span>
                <Input
                  type="file"
                  className="form-control"
                  id="basicpill-firstname-input1"
                  placeholder="Enter Posters"
                  name="image"
                  value={Files1.image}
                  onChange={changeHandler1}
                />
              </div>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  Priority
                  <span className="text-danger">*</span>
                </Label>
                <select
                  value={form1.priority}
                  name="priority"
                  required
                  onChange={e => {
                    handleChange1(e)
                  }}
                  className="form-select"
                >
                  <option value="">Select</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
        <Modal
          size="md"
          isOpen={modal_small2}
          toggle={() => {
            tog_small2()
          }}
          centered
        >
          <ModalHeader className="border-bottom-0">
            {" "}
            <button
              onClick={() => {
                setmodal_small2(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <div className="modal-body">
            <div className="text-center mb-2">
              <div className="avatar-md mx-auto mb-2">
                <div className="avatar-title bg-light  rounded-circle text-primary h1">
                  <i className="bx bx-trash text-danger"></i>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-xl-10">
                  <h4 className="text-danger mb-3">
                    Do you really want to delete this all Posters?
                  </h4>
                </div>
              </div>
            </div>
            <hr></hr>
            <div style={{ float: "right" }}>
              <Button
                onClick={() => {
                  setmodal_small2(false)
                }}
                color="warning"
                type="button"
              >
                Cancel <i className="fas fa-times-circle"></i>
              </Button>

              <Button
                color="danger"
                type="button"
                id="button-addon2"
                className="m-1"
                onClick={() => {
                  DeleteCategory()
                }}
              >
                <i className="bx bx-trash text-white"></i> Delete
              </Button>
            </div>
          </div>
        </Modal>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default Banner
